import { currencySymbol, isEmpty } from "./helpers";
// console.log(currencySymbol());
const val = !isEmpty(currencySymbol()) && currencySymbol();
export const currency = (value) =>
	String.fromCodePoint(parseInt(value || val, 16));
